// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"b14e7e2e","453":"33332f49","455":"3b884edf","977":"8174300e"}[chunkId] + ".chunk.js";
};